import { render } from "./IdGridFooter.vue?vue&type=template&id=34a00517"
import script from "./IdGridFooter.vue?vue&type=script&lang=js"
export * from "./IdGridFooter.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__